<template>
    <div
      style="
        width: 2105px;
        height: 1489px;
        background: url(/static/img/cert.jpg);
        margin: 0 auto;
        text-align: unset;
      "
      id="mainboy"
    >
      <div
        class="text"
        style="margin: auto;
    top: 560px;
    position: relative;
    width: 1473px;
    font-size: 35px;
    letter-spacing: 1px;
    line-height: 92px;"
  
      >
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;经审查决定，您符合入会条件，申请手续完备，同意批准您加入 职业发展规划工作项目组，成为我单位个人会员。
        </p>
      </div>
      <div
        class="text"
        style="left: 0px;top: 628px;position: relative;width: 2105px;color: rgb(229 0 20);text-align: center;font-size: 119px;font-weight: bolder;letter-spacing: 7px;"
      >
        <p>会员证书</p>
      </div>
      <div
        class="text"
        style="left: 279px; top: 799px; position: relative; width: 520px;font-size: 23px; text-align: left;font-size: 25px;"
      >
        <p>姓名：{{ cert.name }}</p>
      </div>
      <div
        class="text"
        style="left: 279px; top: 814px; position: relative; width: 500px;font-size: 25px;"
      >
        <p>会员编号：{{ cert.code }}</p>
      </div>
      <div
        class="text"
        style="left: 279px; top: 829px; position: relative; width: 520px; text-align: left;font-size: 25px;"
      >
        <p>证书性质：个人会员</p>
      </div>
      
       <div
        class="text"
        style="left: 279px; top: 843px; position: relative; width: 800px;font-size: 25px;"
      >
        <p>授权期限：{{formatExcelData(cert.certdate)}}至{{formatExcelData(cert.valieddate)}}</p>
      </div>
      <div
        class="text"
        style="top: 883px;
    position: relative;
    width: 2105px;
    font-size: 19px;
    letter-spacing: 0.2px;
    line-height: 92px;
    text-align: center;
    color: red;"
  
      >
        <p>
          声明:会员证书正本为有效文本，此会员证书仅供会员参阅，其它事宜无效， 职业发展规划工作项目组拥有授权会员证书的最终解释权。
        </p>
      </div>
    </div>
  </template>
  
  <script>
  
  // import QRCode from "qrcodejs2";
  // import VueQr from 'vue-qr'
  export default {
    data() {
      return {
        cert: {level:""},
        global,
        company: "XXXXXXXXXXXXXXXX",
        socilacredit: "XXXXXXXXXXXXXXXXXX",
        smallflag: false,
        fontSize:48,
        codeUrl:""
      };
    },
    components: {},
    created(){
      this.cert = this.$route.query;
    },
    methods: {
     formatExcelData(value) {
      let dataStr = this.formatExcel(value);
      if (isNaN(dataStr) && !isNaN(Date.parse(dataStr))) {
          value = new Date(dataStr);
          if (dataStr.indexOf("/") == -1 && dataStr.indexOf("-") == -1)
              value.setDate(value.getDate() + 1);
          value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
          -2
          )}月${("00" + value.getDate()).slice(-2)}日`;
          return value;
      } else {
          if (dataStr.indexOf("年") > -1) {
              var ttDate = dataStr.match(/\d{4}.\d{1,2}.\d{1,2}/gm).toString();
              ttDate = ttDate.replace(/[^0-9]/gm, "-");
              value = new Date(ttDate);
              value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
              return value;
          } else {
              if (!isNaN(dataStr)) {
                  var data = new Date(1900, 0, dataStr);
                  value = data;
                  value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
                  return value;
              } else {
                  return dataStr;
              }
          }
      }
  },
   formatExcel(value) {
      if (!value) {
          return "";
      } else {
          if (typeof value == "string") {
              return value.trim();
          } else {
              return value.toString().trim();
          }
      }
  }
    },
    mounted() {
      
      // this.creatQrCode(this.cert.code, this.cert.name);
    },
  };
  </script>
  
  <style scoped>
  .positiontext {
    text-align: center;
    font-size: 48px;
    font-family: STZhongsong;
    font-weight: 900;
  }
  .leveltext {
    text-align: center;
    font-size: 48px;
    font-family: STZhongsong;
    color: #fc091f;
    font-weight: 900;
  }
  .text {
    text-align: left;
    font-size: 23px;
    font-family: Microsoft YaHei;
  }
  .companytext {
    text-align: center;
    font-size: 27px;
    font-family: STZhongsong;
    font-weight: 900;
  }
  .companytextsmall {
    text-align: center;
    font-size: 18px;
    font-family: STZhongsong;
    font-weight: 900;
  }
  .companyposit
  {
    left: -3px; top: 60px; position: relative; width: 794px
  }
  .companypositsmall
  {
    left: -3px; top: 81px; position: relative; width: 794px
  }
  .soltext {
    text-align: center;
    font-size: 18.5px;
    font-family: STZhongsong;
    color: #fc091f;
    font-weight: 900;
  }
  .soltextsmall {
    text-align: center;
    font-size: 20px;
    font-family: STZhongsong;
    color: #fc091f;
    font-weight: 900;
  }
  .soltpositsmall
  {
    left: -1px; top: 62px; position: relative; width: 794
  }
  .soltposit{
    left: -1px; top: 33px; position: relative; width: 794
  }
  .text1 {
    text-align: center;
    font-size: 35px;
    font-family: STZhongsong;
  }
  .text2 {
    text-align: left;
    font-size: 20px;
    font-family: STZhongsong;
  }
  .qrcode {
    display: inline-block;
  }
  .qrcode /deep/ canvas img {
    background-color: #fff;
    padding: 6px;
    box-sizing: border-box;
  }
  
  .textchang{
  text-align: center;
      font-size: 30px;
      font-family: STZhongsong;
      line-height: 62px;
  }
  img{
    width: 125px;
      margin-right: 44px;
  }
  </style>
  